import { useQuery, useQueryClient } from '@tanstack/react-query';
import { silentFetch } from '../services/api';
import { TIERS, getEffectiveTier, hasFeature, getTrialInfo, isPaidPro } from '../services/subscription';

// Subscription status from the backend (DynamoDB is the source of truth —
// written by apple-verify and kept fresh by the S2S webhook). silentFetch:
// this runs on app open and must never toast.
export default function useSubscription() {
  const queryClient = useQueryClient();
  const { data: status, isLoading } = useQuery({
    queryKey: ['subscription', 'status'],
    queryFn: () => silentFetch('/subscription/status'),
    staleTime: 60000,
  });

  const tier = getEffectiveTier(status);
  const trial = getTrialInfo(status);
  const paid = isPaidPro(status);
  return {
    tier,
    isPro: tier === TIERS.PRO,
    // isPaidPro distinguishes a real subscriber from a free-trial user.
    isPaidPro: paid,
    // isTrial = access comes ONLY from the app-managed 14-day trial. A paid
    // subscriber inside their first 14 days is Pro, not "on trial" — without
    // the !paid guard the header badge and Settings mislabel real subscribers.
    isTrial: trial.active && !paid,
    trialDaysLeft: trial.daysLeft,
    status: status || null,
    isLoading,
    hasFeature: (featureId) => hasFeature(tier, featureId),
    reload: () => queryClient.invalidateQueries({ queryKey: ['subscription'] }),
  };
}
